import { Routes } from '@angular/router';

import { authGuard } from '@/core/auth/guards/auth/auth.guard';
import { restoreSessionGuard } from '@/core/auth/guards/restore-session/restore-session.guard';
import { rolesGuard } from '@/core/auth/guards/roles/roles.guard';
import { testLoginGuard } from '@/core/auth/guards/test-login/test-login.guard';
import { UserRole } from '@/core/auth/types/auth.types';
import { CodeLoginStore } from '@/features/auth/stores/code-login.store';
import { gradeSlugGuard } from '@/core/routing/guards/grade-slug.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./features/auth/pages/login/login').then((m) => m.Login),
  },
  {
    path: 'login/codigo',
    providers: [CodeLoginStore],
    loadComponent: () =>
      import('./features/auth/pages/code-login/code-login').then((m) => m.CodeLogin),
  },
  {
    path: 'login/test',
    canActivate: [testLoginGuard],
    data: { testLogin: true },
    loadComponent: () => import('./features/auth/pages/login/login').then((m) => m.Login),
  },
  {
    path: 'auth/callback',
    loadComponent: () =>
      import('./features/auth/pages/sso-callback/sso-callback').then((m) => m.SsoCallback),
  },
  {
    path: 'teacher',
    canActivate: [rolesGuard(UserRole.Teacher)],
    loadChildren: () => import('./features/teacher/teacher.routes').then((m) => m.teacherRoutes),
  },
  {
    path: 'healthz',
    loadComponent: () => import('./shared/ui/healthz/healthz').then((m) => m.Healthz),
  },
  {
    path: ':grade',
    canMatch: [gradeSlugGuard('grade')],
    canActivate: [authGuard],
    loadChildren: () => import('./features/student/student.routes').then((m) => m.studentRoutes),
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    // Every unmatched URL renders here, keeping the address the visitor actually typed. The guard
    // restores the session without gating: the page shows for anyone, but only a restored session
    // tells its "back home" button whether to aim at the teacher area or a student's own grade.
    // This is also where NOT_FOUND_URL lands, so no route may claim that path — the param routes
    // above only reach it because `gradeSlugGuard` keeps them from matching anything but a grade.
    path: '**',
    canActivate: [restoreSessionGuard],
    loadComponent: () =>
      import('./features/errors/pages/not-found-page/not-found-page').then((m) => m.NotFoundPage),
  },
];
